export default __webpack_public_path__ + "static/property-img-1-abc347c677a09ec4dc059f60d8e73018.jpg";